import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import settings from "settings"
import _ from "lodash"
import EditLandTractModal from "../modals/editLandTract"
import EditLandFeatureModal from "../modals/editLandFeature"
import AddLandTract from "../modals/addLandTract"
import AddLandFeatureModal from "../modals/addLandFeature"
import FullTable from "components/FullTable"
import numeral from "numeral"
import helpers from "helpers/helpers"

class LandInventory extends Component {
	constructor(props) {
		super(props)

		this.state = {
			editTractModal: false,
			editFeatureModal: false,
			addTractModal: false,
			addFeatureModal: false,
			userData: {},
			tractData: {},
			featureData: {},
			tractColumns: [
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Acreage",
					accessor: "acreage",
				},
				{
					Header: "View",
					accessor: "view",
				},
			],
			featuresColumns: [
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Tract",
					accessor: "tract",
					filterMethod: (f, r) => helpers.tableText(f, r, "tract"),
				},
				{
					Header: "Section",
					accessor: "section",
					filterMethod: (f, r) => helpers.tableText(f, r, "section"),
				},
				{
					Header: "Feature Type",
					accessor: "type",
					filterMethod: (f, r) => helpers.tableText(f, r, "type"),
				},
				{
					Header: "Is Reserve",
					accessor: "reserve",
					filterMethod: (f, r) => helpers.tableText(f, r, "reserve"),
				},
				{
					Header: "Acreage",
					accessor: "acreage",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v.acreage
						})
						return numeral(total).format("0,0.00")
					},
				},
				{
					Header: "View",
					accessor: "view",
				},
			],
		}
	}

	closeModal = (d) => {
		this.setState({
			editTractModal: false,
			editFeatureModal: false,
			addTractModal: false,
			addFeatureModal: false,
		})
	}

	buildTracts = () => {
		let ret = []
		let property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
		_.forEach(this.props.payload.public.land_tracts, (v) => {
			delete v.coordinates
			if (v.property !== this.props.activeProperties[0]) return
			ret.push({
				name: v.name,
				property: property.name || "",
				acreage: v.acreage,
				view: (
					<a
						onClick={() => {
							this.setState({ tractData: v, editTractModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			})
		})
		return ret
	}

	buildFeatures = () => {
		let ret = []
		let property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
		_.forEach(this.props.payload.public.land_features, (v) => {
			delete v.coordinates
			if (v.property !== this.props.activeProperties[0]) return
			let type = _.find(this.props.payload.public.land_feature_types, { id: v.type })
			let section = _.find(this.props.payload.public.sections, { id: v.section_id })
			let tract = _.find(this.props.payload.public.land_tracts, { id: v.tract })
			if(!tract) {
				// try pulling form section
				tract = _.find(this.props.payload.public.land_tracts, { id: section?.tract })
			}
			ret.push({
				name: v.name,
				property: property.name || "",
				acreage: v.acreage,
				reserve: v.section_id ? "Yes" : "No",
				section: section?.name || "",
				type: type ? type.name : "",
				tract: tract ? tract.name : "",
				view: (
					<a
						onClick={() => {
							this.setState({ featureData: v, editFeatureModal: true })
						}}>
						<i className="far fa-edit"></i>
					</a>
				),
			})
		})
		return ret
	}

	render() {
		if (this.props.activeProperties.length !== 1) {
			return (
				<div className="lotStatus__pleaseChoose">
					<h1>Please choose one community to view land inventory.</h1>
				</div>
			)
		} else if (this.props.payloadStatus) {
			return (
				<div>
					<Title title="Land Inventory" showDate={false} />
					<div className="content">
						<h2>Land Tracts</h2>
						<div className="admin__add">
							<i
								className="fas fa-plus-circle"
								onClick={() => {
									this.setState({ addTractModal: true })
								}}
							/>
						</div>
						<FullTable
							data={this.buildTracts()}
							columns={this.state.tractColumns}
							name="landInventory__tracts"
							title="Land Inventory - Tracts"
							unset={["view"]}
						/>
						<h2>Land Features</h2>
						<div className="admin__add">
							<i
								className="fas fa-plus-circle"
								onClick={() => {
									this.setState({ addFeatureModal: true })
								}}
							/>
						</div>
						<FullTable
							data={this.buildFeatures()}
							columns={this.state.featuresColumns}
							name="salesManagers"
							title="Sales Managers"
							unset={["view"]}
						/>
						<AddLandTract
							open={this.state.addTractModal}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<AddLandFeatureModal
							open={this.state.addFeatureModal}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<EditLandTractModal
							open={this.state.editTractModal}
							data={this.state.tractData}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
						<EditLandFeatureModal
							open={this.state.editFeatureModal}
							data={this.state.featureData}
							close={this.closeModal}
							onClose={(d) => {
								this.closeModal(d)
							}}
						/>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(LandInventory)
